<div
  class="items [ block surface-container-lowest ][ m-0 h-inherit max-h-inherit min-w-inherit overflow-auto ][ corner-inherit outline-none ]"
>
  <div class="[ p-b-2xs ]">
    <ng-content></ng-content>
  </div>
</div>
